import React from 'react';
import PropTypes from 'prop-types';
import { Button as BSButton } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import inlineStyles from './Button.module.css';
import Shapes from './Shapes';

Button.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  shape: PropTypes.oneOf([Shapes.circle, Shapes.rounded, Shapes.ellipse]),
  subTitle: PropTypes.string,
  isContentVertical: PropTypes.bool,
  // Style related
  className: PropTypes.string,
  styles: PropTypes.shape({
    container: PropTypes.object,
    text: PropTypes.object
  }),
  isHighlighted: PropTypes.bool,
  isDisabled: PropTypes.bool,
  hasBorder: PropTypes.bool,
  // Callback function
  onClick: PropTypes.func,
  children: PropTypes.node,
  isWrap: PropTypes.bool
};

Button.defaultProps = {
  shape: Shapes.ellipse,
  isHighlighted: true,
  hasBorder: true,
  isContentVertical: false
};

function Button(props) {
  const {
    id,
    icon,
    shape,
    styles: propStyles,
    className: propClassName,
    isHighlighted,
    isDisabled = false,
    hasBorder,
    onClick,
    children,
    isWrap = false,
    isContentVertical,
    subTitle
  } = props;

  let className = inlineStyles.standardBtn;

  if (propClassName) {
    className = [className, propClassName].join(' ');
  }

  if (isDisabled) {
    className = [className, inlineStyles.standardBtnDisabled].join(' ');
  } else {
    if (isHighlighted) {
      className = [className, inlineStyles.highlighted].join(' ');
    } else {
      className = [className, inlineStyles.notHighlighted].join(' ');
    }
  }

  if (!hasBorder) {
    className = [className, inlineStyles.noBorder].join(' ');
  }

  switch (shape) {
    case Shapes.circle:
      className = [className, inlineStyles.circle].join(' ');
      break;
    case Shapes.rounded:
      className = [className, inlineStyles.rounded].join(' ');
      break;
    default:
      break;
  }

  let innerClass = isWrap ? inlineStyles.wrapInner : inlineStyles.inner;

  if (isContentVertical || shape === Shapes.circle) {
    innerClass = [innerClass, inlineStyles.buttonContentVertical].join(' ');
  } else {
    innerClass = [innerClass, inlineStyles.buttonContentHorizontal].join(' ');
  }

  const containerStyle =
    propStyles && propStyles.container ? propStyles.container : {};

  const buttonProps = {
    id,
    className,
    disabled: isDisabled,
    onClick,
    style: { ...containerStyle },
    type: 'button',
    variant: ''
  };

  const iconComponent = () => {
    if (!icon) {
      return;
    }
    if (typeof icon === 'string') {
      let className = inlineStyles.icon;
      if (!children) {
        className = [className, inlineStyles.largeIcon].join(' ');
      }
      return (
        <FontAwesomeIcon
          className={className}
          icon={['fas', icon]}
          fixedWidth
        />
      );
    } else {
      const svgClass = isHighlighted
        ? inlineStyles.svg
        : inlineStyles.invertSvg;
      return <div className={svgClass}>{icon}</div>;
    }
  };

  return (
    <BSButton {...buttonProps}>
      <div className={innerClass}>
        {iconComponent()}
        <div className={inlineStyles.contentContainer}>
          {children}
          {subTitle && (
            <div className={inlineStyles.buttonSubTitle}>{subTitle}</div>
          )}
        </div>
      </div>
    </BSButton>
  );
}

Button.Shapes = Shapes;

export default Button;
